/**
 * Configuration for local MCP servers that should be bridged
 * into client-side tools for FullAgenticChat.
 */

export type McpServerType = "http" | "sse" | "stdio";

export interface McpServerConfig {
  /** Display name used as a tool-name prefix to avoid collisions. */
  name: string;
  /** Base URL of the MCP endpoint. */
  url: string;
  type: McpServerType;
}

const STORAGE_KEY = "mcp-servers";

/** Default servers used when nothing is saved in localStorage. */
export const DEFAULT_MCP_SERVERS: McpServerConfig[] = [
  {
    name: "file-flipper",
    url: "http://localhost:3001/",
    type: "http",
  },
];

/** Load server configs from localStorage, falling back to defaults. */
export function loadMcpServers(): McpServerConfig[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw) as McpServerConfig[];
  } catch {
    // Corrupted data — fall through to defaults
  }
  return DEFAULT_MCP_SERVERS;
}

/** Persist server configs to localStorage. */
export function saveMcpServers(servers: McpServerConfig[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(servers));
}
